// frontend/src/features/ogdb2/ogdb2Api.js
import api from "../../apiClient";

export const OGDB2 = {
  health: () => api.get("/ogdb2/health"),

  // Wells (legacy / still used by Home search)
  createWell: (payload) => api.post("/ogdb2/wells", payload),
  searchWells: (params) => api.get("/ogdb2/wells", { params }),
  searchWellsPost: (payload) => api.post("/ogdb2/wells/search", payload),
  getWell: (wellId) => api.get(`/ogdb2/wells/${wellId}`),
  patchWell: (wellId, payload) => api.patch(`/ogdb2/wells/${wellId}`, payload),

  // Well Metrics (legacy)
  listWellMetrics: (wellId, tax_year) => api.get(`/ogdb2/wells/${wellId}/metrics`, { params: { tax_year } }),
  upsertMetric: (wellId, payload) => api.post(`/ogdb2/wells/${wellId}/metrics`, payload),
  deleteMetric: (wellId, metricId) => api.delete(`/ogdb2/wells/${wellId}/metrics/${metricId}`),
  
  // ✅ Bulk Analysis saved views (server)
  listSavedViews: () => api.get("/ogdb2/views"),
  upsertSavedView: (payload) => api.post("/ogdb2/views", payload),
  deleteSavedView: (viewId) => api.delete(`/ogdb2/views/${viewId}`),

  // Import (legacy OGDB2 CSV)
  downloadTemplatePath: "/ogdb2/import/template.csv",
  importCsv: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/ogdb2/import/csv", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 120000,
    });
  },

  // ✅ BAID / multi-source Excel import (WRITE)
  uploadImportExcel: ({
    file,
    client,
    file_type,
    tax_year,
    appraiser_firm,
    uploaded_by,
    notes,
    create_missing_baids,
    column_mapping,
    crosswalk_file,
    county,
  }) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("client", client);
    fd.append("file_type", file_type);

    if (tax_year !== undefined && tax_year !== null && String(tax_year).trim() !== "") {
      fd.append("tax_year", String(tax_year));
    }
    if (appraiser_firm) fd.append("appraiser_firm", appraiser_firm);
    if (uploaded_by) fd.append("uploaded_by", uploaded_by);
    if (notes) fd.append("notes", notes);

    if (create_missing_baids !== undefined && create_missing_baids !== null) {
      fd.append("create_missing_baids", String(!!create_missing_baids));
    }

    if (Array.isArray(column_mapping) && column_mapping.length) {
      fd.append("column_mapping_json", JSON.stringify(column_mapping));
    }

    if (crosswalk_file) fd.append("crosswalk_file", crosswalk_file);

    // v4 BAID: county required for lease_summary + appraisal_roll imports
    if (county !== undefined && county !== null && String(county).trim() !== "") {
      fd.append("county", String(county).trim());
    }

    return api.post("/ogdb2/imports/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 1200000,
    });
  },

  // ✅ BAID Import preview (NO WRITE)
  previewImportExcel: ({
    file,
    client,
    file_type,
    tax_year,
    appraiser_firm,
    uploaded_by,
    notes,
    create_missing_baids,
    preview_limit = 200,
    crosswalk_file,
    county,
  }) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("client", client);
    fd.append("file_type", file_type);

    if (tax_year !== undefined && tax_year !== null && String(tax_year).trim() !== "") {
      fd.append("tax_year", String(tax_year));
    }
    if (appraiser_firm) fd.append("appraiser_firm", appraiser_firm);
    if (uploaded_by) fd.append("uploaded_by", uploaded_by);
    if (notes) fd.append("notes", notes);

    if (create_missing_baids !== undefined && create_missing_baids !== null) {
      fd.append("create_missing_baids", String(!!create_missing_baids));
    }

    fd.append("preview_limit", String(preview_limit));

    if (crosswalk_file) fd.append("crosswalk_file", crosswalk_file);

    // v4 BAID: county required for lease_summary + appraisal_roll imports
    if (county !== undefined && county !== null && String(county).trim() !== "") {
      fd.append("county", String(county).trim());
    }

    return api.post("/ogdb2/imports/preview", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 1200000,
    });
  },

  // RRC production refresh (fetch from Texas RRC PDQ per-lease)
  refreshRRCProduction: (client, tax_year, { forceAll = false } = {}) =>
    api.post(`/ogdb2/rrc/refresh?client=${encodeURIComponent(client)}&tax_year=${tax_year}&force_all=${forceAll}`, null, { timeout: 600000 }),

  // BAID browsing
  listBAIDUnits: (client, limit = 200) => api.get("/ogdb2/baid/units", { params: { client, limit } }),
  getBAIDUnitDetail: (unitId) => api.get(`/ogdb2/baid/units/${unitId}`),

  // ✅ BAID facts (normalized registry facts in ogdb2_baid_facts)
  listBAIDFacts: (unitId, tax_year) =>
    api.get(`/ogdb2/baid/units/${unitId}/facts`, { params: { tax_year } }),
	
  // ✅ Monthly production (time series)
  getBAIDMonthlyProduction: (unitId, prod_year) =>
    api.get(`/ogdb2/baid/units/${unitId}/production/monthly`, { params: { prod_year } }),

  pivotBAIDMonthlyProduction: (payload) =>
    api.post(`/ogdb2/baid/production/pivot`, payload, { timeout: 120000 }),	

  upsertBAIDFact: (unitId, payload) =>
    api.post(`/ogdb2/baid/units/${unitId}/facts`, payload),

  // Bulk (legacy wells)
  bulkQuery: (payload) => api.post("/ogdb2/bulk/query", payload, { timeout: 120000 }),

  // Bulk (BAIDs / Units)
  bulkQueryBAID: (payload) => api.post("/ogdb2/baid/bulk/query", payload, { timeout: 120000 }),
  
  exportLeaseSummaryXlsx: (payload) =>
    api.post("/ogdb2/baid/export/lease_summary.xlsx", payload, { responseType: "blob", timeout: 180000 }),
  
};

